import documentIcon from 'assests/svg/document-icon.svg';
import successAlert from 'assests/svg/success-alert.svg';
import warningAlert from 'assests/svg/warning-alert.svg';

const NOTIFICATION_TYPE = {
  WARNING: 'toast_warning',
  ERROR: 'toast_error',
  SUCCESS: 'toast_success',
  DEFAULT: 'toast_default',
  ORDER_CONFIRMATION: 'pinkShade'
};

const CLICK_TYPE = {
  LINK: 'link'
};

const IMAGE_TYPE = {
  toast_warning: warningAlert,
  toast_error: warningAlert,
  toast_success: successAlert,
  toast_default: documentIcon
};

export { NOTIFICATION_TYPE, CLICK_TYPE, IMAGE_TYPE };
